// Lib
import React from 'react';
import { TableCell, TableRow as MuiTableRow } from '@mui/material';

const TableRow = ({
  useCellsReducers = () => ({ cells: {} }),
  columns,
  item,
  styles,
}) => {
  const { cells } = useCellsReducers({
    kit: item,
  });

  return (
    <MuiTableRow className={styles?.row}>
      {columns?.map((column) => {
        return (
          <TableCell key={`${item?.id}-${column?.id}`} className={styles?.cell}>
            {cells?.[column?.id]}
          </TableCell>
        );
      })}
    </MuiTableRow>
  );
};

export default TableRow;
